import { jsx as _jsx } from "react/jsx-runtime";
import { useFlags } from "launchdarkly-react-client-sdk";
import { memo } from "react";
import { useSelector } from "react-redux";
import { AssetLocationBreadcrumbs } from "~/components/AssetModal/Header/components/AssetLocationBreadcrumbs";
import { AssetLocationName } from "~/components/AssetModal/Header/components/AssetLocationName";
import { centralizedClipBoardInfoSelector } from "~/store/centralizedClip/selectors";
export const BasicAssetHeaderLocation = /*#__PURE__*/ memo((param)=>{
    let { onClose, workspaceName } = param;
    const { current } = useSelector(centralizedClipBoardInfoSelector);
    const { libraries: librariesFlag } = useFlags();
    if (current) {
        var _current_ancestors;
        if (current.library && !!((_current_ancestors = current.ancestors) === null || _current_ancestors === void 0 ? void 0 : _current_ancestors.length) && librariesFlag) {
            return /*#__PURE__*/ _jsx(AssetLocationBreadcrumbs, {});
        }
        return /*#__PURE__*/ _jsx(AssetLocationName, {
            onClick: onClose,
            location: current.title
        });
    }
    if (workspaceName) {
        return /*#__PURE__*/ _jsx(AssetLocationName, {
            location: workspaceName
        });
    }
    return null;
});
BasicAssetHeaderLocation.displayName = "BasicAssetHeaderLocation";
